// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63f704b1","239":"eab0352a","455":"4a0eb397","488":"b51d605a"}[chunkId] + ".chunk.js";
};